import { ActiveFeature, LotViewName } from '../types/lot.interface'

export const getActiveFeatureConfig = (features: ActiveFeature[], type: LotViewName): ActiveFeature | null => {
    return features.find((feature) => feature.name.toLowerCase() === type.toLowerCase()) ?? null
}
